import { defineMessages } from 'react-intl';

export default defineMessages({
  AccessCommanderRemoteCeateSiteModalSiteNameCancel: {
    defaultMessage: 'Cancel',
    id: 'accessCommanderRemote.ceateSite.modal.siteName.cancel',
  },
  AccessCommanderRemoteCeateSiteModalSiteNameHelperText: {
    defaultMessage: 'Use a descriptive name',
    id: 'accessCommanderRemote.ceateSite.modal.siteName.helperText',
  },
  AccessCommanderRemoteCeateSiteModalSiteNameLabel: {
    defaultMessage: 'Site name',
    id: 'accessCommanderRemote.ceateSite.modal.siteName.label',
  },
  AccessCommanderRemoteCeateSiteModalSiteNameSubmit: {
    defaultMessage: 'Create site',
    id: 'accessCommanderRemote.ceateSite.modal.siteName.submit',
  },
  AccessCommanderRemoteCeateSiteModalText: {
    defaultMessage: 'To learn more about this feature, see the user manual.',
    id: 'accessCommanderRemote.ceateSite.modal.text',
  },
  AccessCommanderRemoteCeateSiteModalTitle: {
    defaultMessage: 'Create Access Commander remote connection site',
    id: 'accessCommanderRemote.ceateSite.modal.title',
  },
  changeSiteTypeModalErrorCancel: {
    defaultMessage: 'Close',
    id: 'changeSiteType.modal.error.cancel',
  },
  changeSiteTypeModalErrorSubmit: {
    defaultMessage: 'Retry',
    id: 'changeSiteType.modal.error.submit',
  },
  changeSiteTypeModalSubmit: {
    defaultMessage: 'Change type',
    id: 'changeSiteType.modal.submit',
  },
  changeSiteTypeModalSubmitMobile: {
    defaultMessage: 'Change',
    id: 'changeSiteType.modal.submitMobile',
  },
  changeSiteTypeModalSuccess: {
    defaultMessage: 'Site type changed successfully',
    id: 'changeSiteType.modal.success',
  },
  changeSiteTypeModalTitle: {
    defaultMessage: 'Change site type',
    id: 'changeSiteType.modal.title',
  },
  createAcomSiteModalCheckboxPasted: {
    defaultMessage: "I've pasted the key to my Access Commander installation",
    id: 'createSite.modal.checkbox.pasted',
  },
  createAcomSiteModalConnectionKeyCopied: {
    defaultMessage: 'Copied!',
    id: 'createSite.modal.connectionKey.copied',
  },
  createAcomSiteModalConnectionKeyHelper: {
    defaultMessage: 'Paste this key to your Access Commander installation',
    id: 'createSite.modal.connectionKey.helper',
  },
  createAcomSiteModalConnectionKeyLabel: {
    defaultMessage: 'Connection key',
    id: 'createSite.modal.connectionKey.label',
  },
  createAcomSiteModalSuccessSnackbar: {
    defaultMessage: 'Site was successfully created.',
    id: 'createAcomSiteModal.success.snackbar',
  },
  CreateSiteModalBack: {
    defaultMessage: 'Back',
    id: 'createSite.modal.back',
  },
  CreateSiteModalCancel: {
    defaultMessage: 'Cancel',
    id: 'createSite.modal.cancel',
  },
  CreateSiteModalError: {
    defaultMessage: 'There was an error, please try again',
    id: 'createSite.modal.error',
  },
  CreateSiteModalNext: {
    defaultMessage: 'Next',
    id: 'createSite.modal.next',
  },
  CreateSiteModalSiteTypeCommercialSubtypeMixedUse: {
    defaultMessage: 'Mixed-use',
    id: 'createSite.modal.siteType.commercial.subtype.mixedUse',
  },
  CreateSiteModalSiteTypeCommercialSubtypeOffice: {
    defaultMessage: 'Office',
    id: 'createSite.modal.siteType.commercial.subtype.office',
  },
  CreateSiteModalSiteTypeCommercialSubtypeOther: {
    defaultMessage: 'Other',
    id: 'createSite.modal.siteType.commercial.subtype.other',
  },
  CreateSiteModalSiteTypeResidentialSubtypeApartmentBuilding: {
    defaultMessage: 'Apartment building',
    id: 'createSite.modal.siteType.residential.subtype.apartmentBuilding',
  },
  CreateSiteModalSiteTypeResidentialSubtypeFamilyHome: {
    defaultMessage: 'Single-family home',
    id: 'createSite.modal.siteType.residential.subtype.familyHome',
  },
  CreateSiteModalSubmit: {
    defaultMessage: 'Create site',
    id: 'createSite.modal.submit',
  },
  CreateSiteModalSubmitMobile: {
    defaultMessage: 'Create',
    id: 'createSite.modal.submitMobile',
  },
  CreateSiteModalSuccess: {
    defaultMessage: 'Site created successfully',
    id: 'createSite.modal.success',
  },
  CreateSiteModalTitle: {
    defaultMessage: 'Create new site',
    id: 'createSite.modal.title',
  },
  createSiteModalValidationSchemaExistName: {
    defaultMessage: 'This site name is already used.',
    id: 'createSiteModalValidationSchemaExistName',
  },
});
